import { Link } from "react-router-dom";
import { KeyRound, ShieldCheck, Accessibility, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { V3Page, V3Aside } from "@/components/control/v3";

const TOPICS = [
  { icon: ShieldCheck, title: "Zugang und Rechte", text: "Rechte werden serverseitig pro Rolle vergeben. Fehlt dir ein Bereich, wende dich an den Super Admin. Rechte lassen sich nicht in der Oberfläche freischalten." },
  { icon: KeyRound, title: "Anmeldung und Zwei-Faktor", text: "Sitzungen, Passwort und Wiederherstellung verwaltest du unter „Mein Konto“.", link: ["/konto", "Mein Konto öffnen"] },
  { icon: Lock, title: "Private Passdaten", text: "Access-Pass-Daten sind nur mit einer persönlichen, zeitlich begrenzten Freigabe des Mitglieds sichtbar – auch nicht über eine Rolle oder Organisation." },
  { icon: Accessibility, title: "Bedienung", text: "Alle Funktionen sind per Tastatur erreichbar. Die Ansicht passt sich an Zoom und grosse Schrift an; Animationen folgen der Systemeinstellung „Bewegung reduzieren“." },
];

export default function Help() {
  const { user } = useAuth();
  return (
    <V3Page crumb="Hilfe" title="Hilfe" subtitle="Antworten zu Zugang, Anmeldung, Passdaten und Bedienung." testId="help-page"
      aside={<V3Aside subjectTitle="Deine Rolle" subject={user?.role_label} note="Für weitere Rechte entscheidet der Super Admin." />}>
      {TOPICS.map((t) => (
        <section key={t.title} className="rounded-xl border border-[#E6E1F0] bg-white px-4 py-4" data-testid={`help-${t.title}`}>
          <h2 className="flex items-center gap-2 text-lg font-bold text-brand-purple"><t.icon className="h-5 w-5 text-brand-magenta" aria-hidden="true" />{t.title}</h2>
          <p className="mt-2 text-sm text-zinc-700">{t.text}</p>
          {t.link && <Link to={t.link[0]} className="mt-2 inline-block text-sm font-semibold text-brand-purple underline">{t.link[1]}</Link>}
        </section>
      ))}
    </V3Page>
  );
}
